import type { Scene } from '@/types'

function sceneCreatedAtMs(scene: Scene): number {
  const timestamp = new Date(scene.createdAt).getTime()
  return Number.isFinite(timestamp) ? timestamp : 0
}

export function hasManualSceneOrder(scene: Scene): boolean {
  return typeof scene.order === 'number' && Number.isFinite(scene.order)
}

export function compareScenesForDisplay(a: Scene, b: Scene): number {
  const aHasOrder = hasManualSceneOrder(a)
  const bHasOrder = hasManualSceneOrder(b)

  if (aHasOrder && bHasOrder && a.order !== b.order) {
    return a.order! - b.order!
  }

  return sceneCreatedAtMs(a) - sceneCreatedAtMs(b)
}

export function getOrderedScenes(scenes: Iterable<Scene>): Scene[] {
  return Array.from(scenes).sort(compareScenesForDisplay)
}
